import { ToastContainerContext } from "@kamae-apps/shared/old/Component/Toast/Context"
import { ToastContainer } from "@kamae-apps/shared/old/Component/Toast/Toast"
import { TFunction } from "i18next"
import { FC, MutableRefObject, ReactNode } from "react"
import { useMatch } from "react-router-dom"
import { useFeatureFlags } from "../../hooks/posthog/useFeatureFlags"
import { MessagePortal } from "../MessagePortal/MessagePortal"
import { Menu } from "../Organisms/Menu/Menu"
import { PageLayout, PageLayoutVariant } from "./PageLayout"

type AppLayoutProps = {
  t: TFunction
  loaded: boolean
  toastRef: MutableRefObject<ToastContainer>
  children: ReactNode
  displayNewBeltModal: boolean
  setDisplayNewBeltModal: React.Dispatch<React.SetStateAction<boolean>>
}

export const AppLayout: FC<AppLayoutProps> = ({
  t,
  loaded,
  toastRef,
  children,
  displayNewBeltModal,
  setDisplayNewBeltModal,
}) => {
  const isPhishingCampaignDetail = useMatch("/phishing/:id") !== null
  const featureFlags = useFeatureFlags()
  const isNewsBarActive = featureFlags.includes("display-news-bar")

  return (
    <>
      <div className="min-h-screen max-w-480 m-auto flex flex-col">
        <MessagePortal
          isNewsBarActive={isNewsBarActive}
          displayNewBeltModal={displayNewBeltModal}
          setDisplayNewBeltModal={setDisplayNewBeltModal}
        />
        <Menu
          t={t}
          isNewsBarActive={isNewsBarActive}
        />
        <ToastContainerContext.Provider value={toastRef}>
          <div className="grow overflow-y-auto overflow-x-hidden scroll-smooth custom-scrollbar relative">
            <PageLayout variant={isPhishingCampaignDetail ? PageLayoutVariant.WHITE : PageLayoutVariant.GLASS}>
              {loaded && children}
              <ToastContainer ref={toastRef} />
            </PageLayout>
          </div>
        </ToastContainerContext.Provider>
      </div>
    </>
  )
}
